module.exports = __webpack_public_path__ + "web/img/sign-70.b633d884.png";